import { useEffect } from "react";
import { getBrand } from '@/helpers/brandHelper.js'

const useFavicon = () => {
  const brand = getBrand()

  useEffect(() => {
    const hasFavicon = document.querySelector('link[rel="icon"]');
    if (hasFavicon) return;
    
    const faviconUrl = `https://bootstrapstorageprod.blob.core.windows.net/assets/${brand}/favicons/favicon.ico`;
    const link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/x-icon";
    link.href = faviconUrl;
    document.head.appendChild(link);
  }, [brand]);

  return {};
};

export default useFavicon;
